<footer class="footer mt-auto d-flex justify-content-center">
   <p class="footer-note mt-1">Copyright © 2023 Halliburton. All Rights Reserved. |
      <a href="https://openearth.community/assets/OEC_Terms_of_Use_2019.9.001.A.pdf" target="_blank"
         class="cursor-pointer">Terms of Use </a>|
      <a href="https://openearth.community/privacy-statement" target="_blank" class="cursor-pointer">Privacy Notice</a>
   </p>
</footer>